import React, {
  useRef,
  useState,
  useEffect,
  lazy,
  Suspense,
  Fragment,
} from "react";
import StyledHeader from "./styled";
import { useLocation, Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { getAssetURL, isMobileOrTablet } from "../../utils";

import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";

const Header = ({ loanOfficerId, user, setUser }) => {
  const [menuToggle, setMenuToggle] = useState(false);
  const [navbarVisible, setNavbarVisible] = useState(true);
  const prevScrollPosRef = useRef(window.scrollY);
  const { pathname } = useLocation();
  const isHome = pathname === "/home" || pathname === "/home/";
  const authorized = user?.authorized || false;

  const handleLogout = () => {
    setUser(null);
    sessionStorage.clear();
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const isMobileOrTabletDevice = isMobileOrTablet();
      setMenuToggle(false);
      if (currentScrollPos === 0) {
        setNavbarVisible(true);
      } else if (prevScrollPosRef.current > currentScrollPos) {
        setNavbarVisible(true);
      } else if (
        prevScrollPosRef.current < currentScrollPos &&
        isMobileOrTabletDevice
      ) {
        setNavbarVisible(false);
      }

      prevScrollPosRef.current = currentScrollPos;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [menuToggle]);

  const getApplyNowURL = () =>
    `https://www.swmc.com/ApplyNow/?extLeadSource=SUNWESTMORTGAGE${
      loanOfficerId && loanOfficerId !== "error" ? `&lof=${loanOfficerId}` : ""
    }`;

  // const getCalculatorURL = () =>
  //   `https://www.swmc.com/loan-calculators-mortgage-calculators${
  //     loanOfficerId && loanOfficerId !== "error" ? `?rlo=${loanOfficerId}` : ""
  //   }`;

  const getAboutURL = () =>
    `https://www.swmc.com/our-history${
      loanOfficerId && loanOfficerId !== "error" ? `?rlo=${loanOfficerId}` : ""
    }`;

  return (
    <StyledHeader
      menuToggle={menuToggle}
      className={`${navbarVisible ? "" : "navbar-hidden"}`}
    >
      <Container fluid="md" className="p-0">
        <Row className="m-0 p-0">
          <Col className="m-0 p-0 w-100 d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-flex-end align-items-center">
              <Link
                as={isHome ? "a" : Link}
                target={isHome ? "_blank" : ""}
                rel="noreferrer"
                href={isHome ? "https://www.swmc.com/" : `/home/`}
                to={isHome ? "https://www.swmc.com/" : `/home/`}
                alt="SWMC-link"
              >
                <div>
                  <Image
                    alt="SWMC Logo"
                    className="header-logo"
                    fluid
                    src="https://resources.swmc.com/swmc-images/sunwest-trust-white-logo.png"
                  />
                </div>
              </Link>
            </div>
            <nav className="desktop m-0 p-0">
            
              <a href={getAboutURL()} target="_blank" rel="noreferrer">
                About
              </a>
              <a
                href="https://www.swmc.com/angelai/calculators"
                target="_blank"
                rel="noreferrer"
              >
                Calculators
              </a>
              <a href={getApplyNowURL()} target="_blank" rel="noreferrer">
                Apply Now
              </a>
              <Link
                to={"/home/"}
                onClick={handleLogout}
                className={`${authorized ? "d-static" : "d-none"}`}
              >
                Logout
              </Link>
              <div className="userwaydiv-desktop">
                <UserWayAccessibilityMenu
                  color="white"
                  width={40}
                  height={40}
                />
                </div>
            </nav>
            
            <Image
              alt="menu"
              className="menu-icon"
              src={getAssetURL("menu-icon.svg")}
              onClick={() => setMenuToggle((prev) => !prev)}
            />
          </Col>
        </Row>
        {menuToggle && (
          <Row className="m-0 p-0">
            <Col className="m-0 p-0">
              <nav className="mobile">
              <div className="userwaydiv-mobile">
                <UserWayAccessibilityMenu
                  color="white"
                  width={40}
                  height={40}
                />
                </div>
                <a href={getAboutURL()} target="_blank" rel="noreferrer">
                  About
                </a>
                <a
                  href="https://www.swmc.com/angelai/calculators"
                  target="_blank"
                  rel="noreferrer"
                >
                  Calculators
                </a>
                <a href={getApplyNowURL()} target="_blank" rel="noreferrer">
                  Apply Now
                </a>
                <Link
                  to={"/home/"}
                  onClick={handleLogout}
                  className={`${authorized ? "d-static" : "d-none"}`}
                >
                  Logout
                </Link>
              </nav>
            </Col>
          </Row>
        )}
      </Container>
    </StyledHeader>
  );
};

export default Header;
